<ng-template [ngIf]="dashboardAccess">
  <div *ngIf="!showPlansInfo" class="dashboard-css" style="background: #F5F5F5; padding: 16px;">
    <div class="row title-bar" style="margin-bottom: 16px;">
      <div class="medium-12 title">Dashboard</div>
    </div>
    <div class="row d-flex flex-dir-row upload-section mb-3">
      <div class="d-flex pb-3 align-items-center" style="width: 65%">
        <div class="bot-on-upload">
          <img src="../../images/jaine-bot.png"/>
        </div>
        <div class="ps-3 upload-notes">
          <div class="head">Auto create client plans with Jaine!</div>
          <div class="text pb-0 mb-2">Hey, It's a RAP (We read, analyze and propose tax strategies) in minutes! Files are now auto redacted upon upload.</div>
          <!-- <div class="float-left me-3">
            <label class="upload-button pointer" for="planFileUpload"><i class="material-icons upload-icon">add</i> Upload Document</label>
            <input type="file" accept=".pdf,image/*" id="planFileUpload" (change)="startUpload($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
          </div> -->
          <div
            ng2FileDrop
            [ngClass]="{ 'nv-file-over': hasDropZoneOver }"
            (fileOver)="fileOverBase($event)"
            [uploader]="uploader"
            class="bulk-upload-drop-zone float-left"
            (click)="fileInput.click()"
          >
          To upload 1040 forms, click or drag & drop them here<br>
            <span style="font-size: 0.85rem; display: block; text-align: center;">
            (use government copies when available)
            </span>
          </div>
          <input
            type="file"
            accept=".pdf,image/*"
            id="planFileUpload"
            class="show-for-sr"
            ng2FileSelect
            [uploader]="uploader"
            multiple
            #fileInput
          />
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-end" style="width: 35%">
        <div class="upload-frame">
          <img src="../../images/dashboard-upload/upload-frame.png"/>
        </div>
      </div>
    </div>
    <div *ngIf="!dashboardMetrics" class="row" style="margin-bottom: 16px;">
      <div class="medium-3" *ngFor="let i of [0,1,2,3]">
        <div class="skeleton-card" style="margin-right: 16px;">
          <div class="skeleton-line" style="width: 45%; height: 13px; margin-bottom: 14px;"></div>
          <div class="skeleton-line" style="width: 55%; height: 28px;"></div>
        </div>
      </div>
    </div>
    <div *ngIf="dashboardMetrics" class="row" style="margin-bottom: 16px;">
      <div class="medium-3">
        <div class="count-box" style="margin-right: 16px;">
          <div class="count-box-title"><img src="../../images/tpiq-icons/dashboard/people_icon_green.png"
                                            style="color: #01AEE6;margin-right: 16px;">Clients
          </div>
          <div class="count-box-text">
            <div class="d-flex justify-content-around pointer" (click)="onClientsSplitClick($event)">
              <div><a
                style="text-decoration: underline">{{dashboardMetrics.active_clients || 0}}</a></div>
              <div><span class="active-clients-badge">Active</span></div>
              <div style="color: #667085">|</div>
              <div><a
                style="text-decoration: underline">{{dashboardMetrics.draft_clients || 0}}</a></div>
              <div><span class="draft-clients-badge">Draft</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="medium-3">
        <div class="count-box" style="margin-right: 16px;">
          <div class="count-box-title"><img src="../../images/tpiq-icons/dashboard/icon1.png"
                                            style="color: #01AEE6;margin-right: 16px;">No of Plans
          </div>
          <div class="count-box-text">{{dashboardMetrics.total_plans || ''}}</div>
        </div>
      </div>
      <div class="medium-3">
        <div class="count-box" style="margin-right: 16px;">
          <div class="count-box-title">
            <ng-template [ngIf]="!savingsEditable">
              <img src="../../images/tpiq-icons/dashboard/icon2.png" style="color: #01AEE6;margin-right: 16px;">Tax
              Savings {{filterYearForSavings || ''}}
              <i (click)="toggleSavings()" class="material-icons pointer"
                 style="font-size: 18px;position: relative;top: 2px;">mode_edit</i>
            </ng-template>
            <ng-template [ngIf]="savingsEditable">
              <span>
                Tax Savings for <span (click)="toggleSavings()"
                                      class="material-icons pointer icon float-right">clear</span>
              </span>
              <label>
                <app-tpiq-select-dropdown (onValueSelect)="setYear($event, 'year tax savings')" [includeNone]="false" [setData]="yearsForSavings"
                                          [setDefaultValue]="filterYearForSavings" [setPlaceHolder]="'Year'"
                                          [setSearchKey]="'name'"
                                          [setValueKey]="'id'"></app-tpiq-select-dropdown>
              </label>
              <div class="mt-2">{{totalTaxSavings | formatAmount:'$0,0'}}</div>
            </ng-template>
          </div>
          <div *ngIf="!savingsEditable" class="count-box-text">{{totalTaxSavings | formatAmount:'$0,0'}}</div>
        </div>
      </div>
      <div class="medium-3">
        <div class="count-box">
          <div class="count-box-title"><img src="../../images/tpiq-icons/dashboard/icon3.png"
                                            style="color: #01AEE6;margin-right: 16px;">Published
          </div>
          <div class="count-box-text">{{dashboardMetrics.publish_count || ''}}</div>
        </div>
      </div>
    </div>
    <div class="d-flex dashboard-grids flex-wrap justify-content-left" id="dashboard-grids">
      <ng-container *ngFor="let grid of gridOrder">
        <ng-container *ngIf="this[grid]">
          <ng-container [ngTemplateOutlet]="this[grid]"></ng-container>
        </ng-container>
      </ng-container>
      <ng-template #publishedSavings>
        <div class="dashboard-grid" id="publishedSavings">
          <div class="graph-container">
            <div class="grid-content-width grid-title new-input-fields">
              <span>Total Published Tax Savings</span>
              <span *ngIf="!yearFilterAllExist" style="margin-left: 16px;float: right;position: relative;top: 10px;">
              <label>
                <span class='badge-tooltip'>
                  <input (click)="setTaxPlanningsDefaultYear()" [(ngModel)]="taxPlanningsDefaultYear" [disabled]="taxPlanningsDefaultYear"
                         class="pointer" type="checkbox"/>
                  <span class='bottomTooltiptext'
                        style='font-size: 13px !important;width: 150px !important;left: 0px !important;'>Default to this year</span>
                </span>
              </label>
            </span>
              <span style="margin-left: 16px;float: right;width: 16%">
              <label>
                <app-tpiq-select-dropdown (onValueSelect)="setYear($event)" [includeNone]="false" [setData]="filterYears"
                                          [setDefaultValue]="yearFilter" [setPlaceHolder]="'Select year'" [setSearchKey]="'name'"
                                          [setValueKey]="'id'"></app-tpiq-select-dropdown>
              </label>
            </span>
              <span style="margin-left: 16px;float: right;width: 20%">
              <label>
                <app-tpiq-select-dropdown (onValueSelect)="setGraphType($event)" [includeNone]="false"
                                          [setData]="graphRelatedTypes" [setDefaultValue]="defaultGraphType"
                                          [setPlaceHolder]="'Select Type'" [setSearchKey]="'type'"
                                          [setValueKey]="'type'"></app-tpiq-select-dropdown>
              </label>
            </span>
            </div>
            <div *ngIf="hasTotalSavingsByStrategyData" class="charts-main" style="min-width: 500px;height:250px;">
              <highcharts-chart [Highcharts]="Highcharts" [options]="groupedTotalTaxSavingsByStrategyChartOptions"
                                style="width: 100%; height: 250px; display: block"></highcharts-chart>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Dev Name : Ishan batish
      Remove the Announcement Tile (section) form the dashboard on date : 12-sep-2025 -->

      <!-- <ng-template #announcements>
        <div class="dashboard-grid" id="announcements">
          <div class="graph-container">
            <div class="grid-content-width">
              <span
                style="font-weight: 500;font-family: Poppins-Regular;font-size: 20px;color: #333333;">Announcements</span>
              <span (click)="navigateToAnouncements()" class="pointer text-decoration-underline float-right"
                    style="color: #0AA8E2; font-size: 14px;">View All</span>
            </div>
            <div class="grid-content-width">
              <div class="row-padding-bottom" style="padding-top: 15px;">
                <div class="no-hover client-todos tax-strategy client-plans badge-tables"
                     style="height: 30vh;overflow-y: scroll;padding: 0;">
                  <div class="tpiq-paginated-table invoices scenarios">
                    <table style="margin-top: 0 !important;font-size: 15px;color: #333333;">
                      <thead>
                      <tr>
                        <th *ngFor="let column of columns">
                          <span>{{column.title}}</span>
                        </th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <ng-template [ngIf]="announcementsList && announcementsList.length == 0">
                        <tr class="text-center">
                          <td [attr.colspan]="columns.length">
                            <div class="callout text-center">
                              <p>No Results Found.</p>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template [ngIf]="announcementsList && announcementsList.length > 0">
                        <tr *ngFor="let row of announcementsList;let i=index" class="pointer">
                          <td (click)="navigateToAnnouncementPage(row)" *ngFor="let col of columns;let idx=index">
                            <div *ngIf="col.name != 'description'" class="pointer table-col">
                              {{row[col.name]}}
                            </div>
                            <div *ngIf="col.name == 'description'" class="pointer text-ellipsis richText-truncate">
                              <div [innerHTML]="row[col.name]"></div>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template> -->
      <ng-template #popularStrategies>
        <div class="dashboard-grid" id="popularStrategies">
          <div class="strategies-graph-container" style="margin-bottom: 16px;">
            <div class="grid-content-width grid-title new-input-fields" style="margin-bottom: 16px;">
              <span>TaxPlanIQ Top 5 Most Popular Strategies</span>
              <span *ngIf="!yearFilterForTop5StrategiesExist"
                    style="margin-left: 16px;float: right;position: relative;top: 5px;">
                  <span class='badge-tooltip'>
                    <input (click)="setTop5StrategiesDefaultYear()" [(ngModel)]="top5StrategiesDefaultYear" [disabled]="top5StrategiesDefaultYear"
                           class="pointer" type="checkbox"/>
                    <span class='bottomTooltiptext'
                          style='font-size: 13px !important;width: 120px !important;left: 0px !important;'>Default to this year</span>
                  </span>
                </span>
              <span style="margin-left: 16px;float: right;width: 20%;">
                  <label>
                    <app-tpiq-select-dropdown (onValueSelect)="setYear($event, 'top 5 strategies')" [includeNone]="false"
                                              [setData]="filterYears" [setDefaultValue]="yearFilterForTop5Strategies"
                                              [setPlaceHolder]="'Select year'" [setSearchKey]="'name'"
                                              [setValueKey]="'id'"></app-tpiq-select-dropdown>
                  </label>
                </span>
            </div>
            <div *ngIf="hasTop5strategiesData" class="charts-main grid-content-width"
                 style="min-width: 500px;height:250px;">
              <highcharts-chart [Highcharts]="Highcharts" [options]="top5strategies"
                                style="width: 100%; height: 250px; display: block"></highcharts-chart>
              <div class="graph-text">*Based on the most popular strategies used by all clients.</div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #tasks>
        <div class="dashboard-grid" id="tasks">
          <div class="graph-container" style="margin-right: 16px;">
            <div class="grid-content-width">
              <span style="font-weight: 500;font-family: Poppins-Regular;font-size: 20px;color: #333333;">Tasks</span>
              <span (click)="navigateToTasks()" class="pointer text-decoration-underline float-right"
                    style="color: #0AA8E2; font-size: 14px;">View All</span>
            </div>
            <div class="grid-content-width">
              <app-dashboard-tasks></app-dashboard-tasks>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #todos>
        <div class="dashboard-grid" id="todos">
          <div class="graph-container">
            <div class="grid-content-width">
              <span style="font-weight: 500;font-family: Poppins-Regular;font-size: 20px;color: #333333;">ToDo's</span>
              <span (click)="navigateToTodos()" class="pointer text-decoration-underline float-right"
                    style="color: #0AA8E2; font-size: 14px;">View All</span>
            </div>
            <div class="grid-content-width">
              <app-dashboard-todos></app-dashboard-todos>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div *ngIf="showPlansInfo" class="row">
    <div class="column small-12 medium-12 large-12">
      <app-dashboard-clients-info [filterYear]="plansFilterYear" [strategyId]="plansFilterStrategyId"
                                  [type]="filterType"></app-dashboard-clients-info>
    </div>
  </div>
</ng-template>

<div *ngIf="!dashboardAccess">
  <app-tpiq-static-dashboard></app-tpiq-static-dashboard>
</div>

<div *ngIf="reveal['addOrEditAnnouncement']">
  <div [ngClass]="{'tpiq-reveal': reveal['addOrEditAnnouncement']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['addOrEditAnnouncement']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span *ngIf="org == 'trialtaxplaniq' || org == 'test-taxplaniq' || org == 'stag-taxplaniq'"
            class="float-left">{{editMode ? 'Update Announcement' : 'Create a New Announcement'}} </span>
      <span *ngIf="org != 'trialtaxplaniq' && org != 'test-taxplaniq' && org != 'stag-taxplaniq'" class="float-left">View Announcement</span>
      <span (click)="hideReveal('addOrEditAnnouncement')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <tpiq-create-update-announcement (onCancelCreateOrUpdateOfAnnouncement)="hideReveal('addOrEditAnnouncement')" (onCreationOrUpdateOfAnnouncement)="refreshListOfAnnouncements()"
                                       [announcementId]="announcementId"
                                       [editMode]="editMode"></tpiq-create-update-announcement>

    </div>
  </div>
</div>

<div *ngIf="reveal['activeAnnouncementsExist']">
  <div [ngClass]="{'tpiq-reveal': reveal['activeAnnouncementsExist']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['activeAnnouncementsExist']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">{{'Active Announcements'}} </span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <div class="row">
        <ng-template [ngIf]="currentActiveAnnouncementToShow">
          <div class="medium-12 columns mt-1 mb-3">
            <label
              style="font-weight: 600;color: #333333;font-size: 1.5rem;">{{currentActiveAnnouncementToShow.name}}</label>
          </div>
          <div class="medium-12 columns">
            <div [innerHTML]="currentActiveAnnouncementToShow.description"
                 style="max-height: 350px;overflow-y: scroll;"></div>
          </div>
        </ng-template>
        <div class="medium-12 columns mt-2">
          <button (click)="showNextActiveAnnouncement(currentAnnouncementIndex + 1)" *ngIf="activeAnnouncements[currentAnnouncementIndex+1]"
                  class="button small float-right">Next
          </button>
          <button (click)="hideReveal('activeAnnouncementsExist')" *ngIf="!activeAnnouncements[currentAnnouncementIndex+1]"
                  class="button small float-right">Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<app-client-select-create
  *ngIf="reveal['openCreateClientPopup']"
  [clientsList]="clientsList"
  [uploader]="uploader"
  [uploadSourceId]="uploadSourceId"
  (onClientSelected)="handleClientSelected($event)"
  (onClientCreated)="handleClientCreated($event)"
  (onUpload)="handleUpload()"
  (onCancel)="hideReveal('openCreateClientPopup')">
</app-client-select-create>

<div *ngIf="reveal['openBulkUploadPopup']" class="bulk-upload-popup">
  <div class="reveal-overlay" [ngClass]="{'qount-reveal': reveal['openBulkUploadPopup']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'qount-reveal': reveal['openBulkUploadPopup']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Upload Queue</span>
      <span class="float-right pointer" (click)="hideReveal('openBulkUploadPopup')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <div class="d-flex flex-column px-3 new-input-fields">
        <div class="d-flex align-items-start gap-3 mb-3" *ngFor="let item of uploader.queue">
          <img src="../../images/pdf-icon.svg" style="max-width: 45px; width: 100%;" alt="pdf icon" />
          <div class="d-flex flex-column gap-2 flex-grow-1">
            <strong class="w-100 text-break">{{ item?.file?.name }}</strong>
            <div style="background: #eee; height: 10px; width: 100%; border-radius: 3px;" *ngIf="item.progress">
              <div [style.width.%]="item.progress" [ngStyle]="{
                'background': 'green',
                'height': '100%',
                'border-radius': '3px'
              }"></div>
            </div>
          </div>
          <div class="text-center">
            <span *ngIf="item.isSuccess" class="badge badge-pill badge-success position-relative">Success</span>
            <span *ngIf="item.isError"  class="badge badge-pill badge-danger position-relative">Failed</span>
          </div>
          <div>
            <button class="small alert text-danger" (click)="item.remove()">
              <mat-icon>delete</mat-icon></button>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-end">
          <button *ngIf="uploadCanceled"
          type="button"
          class="button small float-right mb-0 mt-3"
          (click)="resumeUpload()"
          [disabled]="uploader.isUploading"
        >
          Resume
          </button>
          <button
            *ngIf="!showUploadContinueBtn"
            type="button"
            class="button small float-right mb-0 mt-3"
            (click)="cancelUpload()"
            [disabled]="!uploader.isUploading"
          >
            Cancel
          </button>
          <!-- Continue button if some files failed -->
          <button
            *ngIf="showUploadContinueBtn"
            type="button"
            class="button small float-right mb-0 mt-3"
            (click)="redirectToDraft()"
          >
            Continue
          </button>
      </div>
      </div>
    </div>
  </div>
</div>
